import React, { ChangeEvent, useState } from 'react';

import { getCarrierProfile, saveSuperDispatchInformation } from '../../../API/carrierProfile';
import { getDrivers } from '../../../API/drivers';
import { startSyncSuperDispatch, syncSuperDispatchLoads } from '../../../API/loads';
import Button from '../../../components/Button/Button';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { useAppDispatch } from '../../../store/hooks';
import { CheckboxBlock } from '../../Settings/DriverApp/driverApp.style';
import {
  Block,
  Bottom,
  ButtonSave,
  Error,
  Input,
  InputField,
  Label,
} from '../CarrierInformation/carrierInformation.style';

export const SuperDispatchInformation = ({ data }) => {
  const dispatch = useAppDispatch();
  const [clientId, setClientId] = useState<string>(data?.superdispatch_client_id ? data?.superdispatch_client_id : '');
  const [clientSecret, setClientSecret] = useState<string>(
    data?.superdispatch_client_secret ? data?.superdispatch_client_secret : ''
  );
  const [carrierId, setCarrierId] = useState<string>(
    data?.superdispatch_carrier_id ? data?.superdispatch_carrier_id : ''
  );
  const [superDispatchEnabled, setSuperDispatchEnabled] = useState<boolean>(
    data?.superdispatch_enabled ? data?.superdispatch_enabled : ''
  );

  const [driverDefaultPassword, setDriverDefaultPassword] = useState<string>(
    data?.superdispatch_driver_default_password ? data?.superdispatch_driver_default_password : ''
  );

  const [err, setErr] = useState({
    message: '',
    errors: {
      superdispatch_client_id: [],
      superdispatch_client_secret: [],
      superdispatch_carrier_id: [],
      superdispatch_driver_default_password: [],
    },
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append(`superdispatch_client_id`, clientId);
    formData.append(`superdispatch_client_secret`, clientSecret);
    formData.append(`superdispatch_carrier_id`, carrierId);
    formData.append(`superdispatch_enabled`, superDispatchEnabled ? '1' : '0');
    formData.append(`superdispatch_driver_default_password`, driverDefaultPassword);

    const res: any = await dispatch(saveSuperDispatchInformation(formData));

    if (superDispatchEnabled) {
      await dispatch(startSyncSuperDispatch());
      await dispatch(syncSuperDispatchLoads());
      await dispatch(getDrivers(null));
    }

    if (res.type === 'carrierProfile/carrier_information/rejected') {
      return setErr(res.payload);
    }

    dispatch(getCarrierProfile(null));
    setIsLoading(false);
  };

  return (
    <Block>
      <InputField>
        <Label htmlFor="superdispatch_client_id">SuperDispatch Client Id</Label>
        <Input
          id="superdispatch_client_id"
          type="text"
          style={{
            border: err.errors?.superdispatch_client_id?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
          }}
          onFocus={() => setErr({ ...err, errors: { ...err.errors, superdispatch_client_id: [] } })}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setClientId(e.target.value)}
          value={clientId}
        />
        <Error style={{ bottom: '-17px' }}>{err.errors?.superdispatch_client_id?.[0]}</Error>
      </InputField>
      <InputField>
        <Label htmlFor="superdispatch_client_secret">SuperDispatch Client Secret</Label>
        <Input
          id="superdispatch_client_secret"
          type="text"
          style={{
            border: err.errors?.superdispatch_client_secret?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
          }}
          onFocus={() => setErr({ ...err, errors: { ...err.errors, superdispatch_client_secret: [] } })}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setClientSecret(e.target.value)}
          value={clientSecret}
        />
        <Error style={{ bottom: '-17px' }}>{err.errors?.superdispatch_client_secret?.[0]}</Error>
      </InputField>
      <InputField>
        <Label htmlFor="superdispatch_carrier_id">SuperDispatch Carrier Id</Label>
        <Input
          id="superdispatch_carrier_id"
          type="text"
          style={{
            border: err.errors?.superdispatch_carrier_id?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
          }}
          onFocus={() => setErr({ ...err, errors: { ...err.errors, superdispatch_carrier_id: [] } })}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setCarrierId(e.target.value)}
          value={carrierId}
        />
        <Error style={{ bottom: '-17px' }}>{err.errors?.superdispatch_carrier_id?.[0]}</Error>
      </InputField>
      <InputField>
        <Label htmlFor="driver_default_password">Default Driver Password</Label>
        <Input
          id="driver_default_password"
          type="text"
          style={{
            border: err.errors?.superdispatch_driver_default_password?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
          }}
          onFocus={() => setErr({ ...err, errors: { ...err.errors, superdispatch_driver_default_password: [] } })}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setDriverDefaultPassword(e.target.value)}
          value={driverDefaultPassword}
        />
        <Error style={{ bottom: '-17px' }}>{err.errors?.superdispatch_driver_default_password?.[0]}</Error>
      </InputField>
      <CheckboxBlock>
        <Checkbox
          title="Enable SuperDispatch"
          checkboxName="enablePenguin"
          checked={superDispatchEnabled}
          setChecked={() => setSuperDispatchEnabled(!superDispatchEnabled)}
        />
      </CheckboxBlock>
      <Bottom>
        <ButtonSave>
          <Button
            text="Save Changes"
            pad="8px 24px"
            loading={isLoading}
            loadingText="Saving..."
            handleButton={handleConfirm}
          />
        </ButtonSave>
      </Bottom>
    </Block>
  );
};
